var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArtsCulture = function SvgArtsCulture(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34791_3606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.06582 20.5714C7.52241 20.5714 8.7032 19.3905 8.7032 17.934C8.7032 16.4774 7.52241 15.2967 6.06582 15.2967C4.60925 15.2967 3.42847 16.4774 3.42847 17.934C3.42847 19.3905 4.60925 20.5714 6.06582 20.5714Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9339 17.2747C19.3905 17.2747 20.5714 16.0939 20.5714 14.6374C20.5714 13.1808 19.3905 12 17.9339 12C16.4774 12 15.2966 13.1808 15.2966 14.6374C15.2966 16.0939 16.4774 17.2747 17.9339 17.2747Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5712 14.5878V4.09404C20.5707 3.99164 20.547 3.89074 20.502 3.7991C20.457 3.70746 20.3918 3.62753 20.3115 3.56546C20.2312 3.5034 20.1381 3.46086 20.0391 3.44112C19.9401 3.42137 19.838 3.42495 19.7405 3.45157L9.19104 6.42302C9.05162 6.46112 8.9284 6.5446 8.84025 6.66067C8.75211 6.77673 8.70394 6.91894 8.70312 7.06549V17.934",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70312 10.6812L20.5712 7.38452",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34791_3606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArtsCulture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arts-culture.c7801b238d91a527f4104664ae4c185d.svg";